/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  com: {
    nested: {
      newmedia: {
        nested: {
          metrics: {
            options: {
              optimize_for: "LITE_RUNTIME",
              "(elixir_module_prefix)": "KC.Proto.Metrics",
              swift_prefix: ""
            },
            nested: {
              CallPush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      INCOMING: 0
                    }
                  }
                }
              },
              TimelinePush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      LIKE: 0,
                      COMMENT: 1,
                      SHARE: 2,
                      MENTION: 3
                    }
                  }
                }
              },
              ChatPush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      NEW_MESSAGE: 0,
                      LIKED_MESSAGE: 1
                    }
                  }
                }
              },
              CommunityPush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      INVITATION: 0,
                      JOIN_REQUEST: 1,
                      JOIN_REQUEST_ACCEPTED: 2
                    }
                  }
                }
              },
              SuperUserPush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      POST: 0,
                      BROADCAST: 1
                    }
                  }
                }
              },
              OtherPush: {
                fields: {
                  type: {
                    type: "Type",
                    id: 1
                  }
                },
                nested: {
                  Type: {
                    values: {
                      KINGSPASS_TICKET: 0
                    }
                  }
                }
              },
              PushReceived: {
                oneofs: {
                  push: {
                    oneof: [
                      "call",
                      "chat",
                      "timeline",
                      "community",
                      "superuser",
                      "other"
                    ]
                  }
                },
                fields: {
                  notificationId: {
                    type: "string",
                    id: 1
                  },
                  deliveryId: {
                    type: "string",
                    id: 2
                  },
                  userId: {
                    type: "string",
                    id: 3
                  },
                  deviceId: {
                    type: "string",
                    id: 4
                  },
                  receivedAt: {
                    type: "int64",
                    id: 5
                  },
                  localUserId: {
                    type: "string",
                    id: 6
                  },
                  call: {
                    type: "CallPush",
                    id: 7
                  },
                  chat: {
                    type: "ChatPush",
                    id: 8
                  },
                  timeline: {
                    type: "TimelinePush",
                    id: 9
                  },
                  community: {
                    type: "CommunityPush",
                    id: 10
                  },
                  superuser: {
                    type: "SuperUserPush",
                    id: 11
                  },
                  other: {
                    type: "OtherPush",
                    id: 12
                  },
                  scheduledAt: {
                    type: "int64",
                    id: 13
                  }
                }
              },
              PushesReceivedRequest: {
                fields: {
                  pushes: {
                    rule: "repeated",
                    type: "PushReceived",
                    id: 1
                  },
                  platform: {
                    type: "Platform",
                    id: 2
                  },
                  localPlatform: {
                    type: "Platform",
                    id: 3
                  },
                  applicationVersion: {
                    type: "string",
                    id: 4
                  }
                },
                nested: {
                  Platform: {
                    values: {
                      ANDROID: 0,
                      IOS: 1,
                      WEB: 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  elixirModulePrefix: {
    type: "string",
    id: 1047,
    extend: "google.protobuf.FileOptions"
  },
  google: {
    nested: {
      protobuf: {
        options: {
          go_package: "github.com/golang/protobuf/protoc-gen-go/descriptor;descriptor",
          java_package: "com.google.protobuf",
          java_outer_classname: "DescriptorProtos",
          csharp_namespace: "Google.Protobuf.Reflection",
          objc_class_prefix: "GPB",
          cc_enable_arenas: true,
          optimize_for: "SPEED"
        },
        nested: {
          FileDescriptorSet: {
            fields: {
              file: {
                rule: "repeated",
                type: "FileDescriptorProto",
                id: 1
              }
            }
          },
          FileDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              "package": {
                type: "string",
                id: 2
              },
              dependency: {
                rule: "repeated",
                type: "string",
                id: 3
              },
              publicDependency: {
                rule: "repeated",
                type: "int32",
                id: 10,
                options: {
                  packed: false
                }
              },
              weakDependency: {
                rule: "repeated",
                type: "int32",
                id: 11,
                options: {
                  packed: false
                }
              },
              messageType: {
                rule: "repeated",
                type: "DescriptorProto",
                id: 4
              },
              enumType: {
                rule: "repeated",
                type: "EnumDescriptorProto",
                id: 5
              },
              service: {
                rule: "repeated",
                type: "ServiceDescriptorProto",
                id: 6
              },
              extension: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 7
              },
              options: {
                type: "FileOptions",
                id: 8
              },
              sourceCodeInfo: {
                type: "SourceCodeInfo",
                id: 9
              },
              syntax: {
                type: "string",
                id: 12
              }
            }
          },
          DescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              field: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 2
              },
              extension: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 6
              },
              nestedType: {
                rule: "repeated",
                type: "DescriptorProto",
                id: 3
              },
              enumType: {
                rule: "repeated",
                type: "EnumDescriptorProto",
                id: 4
              },
              extensionRange: {
                rule: "repeated",
                type: "ExtensionRange",
                id: 5
              },
              oneofDecl: {
                rule: "repeated",
                type: "OneofDescriptorProto",
                id: 8
              },
              options: {
                type: "MessageOptions",
                id: 7
              },
              reservedRange: {
                rule: "repeated",
                type: "ReservedRange",
                id: 9
              },
              reservedName: {
                rule: "repeated",
                type: "string",
                id: 10
              }
            },
            nested: {
              ExtensionRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  },
                  options: {
                    type: "ExtensionRangeOptions",
                    id: 3
                  }
                }
              },
              ReservedRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  }
                }
              }
            }
          },
          ExtensionRangeOptions: {
            fields: {
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          FieldDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              number: {
                type: "int32",
                id: 3
              },
              label: {
                type: "Label",
                id: 4
              },
              type: {
                type: "Type",
                id: 5
              },
              typeName: {
                type: "string",
                id: 6
              },
              extendee: {
                type: "string",
                id: 2
              },
              defaultValue: {
                type: "string",
                id: 7
              },
              oneofIndex: {
                type: "int32",
                id: 9
              },
              jsonName: {
                type: "string",
                id: 10
              },
              options: {
                type: "FieldOptions",
                id: 8
              }
            },
            nested: {
              Type: {
                values: {
                  TYPE_DOUBLE: 1,
                  TYPE_FLOAT: 2,
                  TYPE_INT64: 3,
                  TYPE_UINT64: 4,
                  TYPE_INT32: 5,
                  TYPE_FIXED64: 6,
                  TYPE_FIXED32: 7,
                  TYPE_BOOL: 8,
                  TYPE_STRING: 9,
                  TYPE_GROUP: 10,
                  TYPE_MESSAGE: 11,
                  TYPE_BYTES: 12,
                  TYPE_UINT32: 13,
                  TYPE_ENUM: 14,
                  TYPE_SFIXED32: 15,
                  TYPE_SFIXED64: 16,
                  TYPE_SINT32: 17,
                  TYPE_SINT64: 18
                }
              },
              Label: {
                values: {
                  LABEL_OPTIONAL: 1,
                  LABEL_REQUIRED: 2,
                  LABEL_REPEATED: 3
                }
              }
            }
          },
          OneofDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              options: {
                type: "OneofOptions",
                id: 2
              }
            }
          },
          EnumDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              value: {
                rule: "repeated",
                type: "EnumValueDescriptorProto",
                id: 2
              },
              options: {
                type: "EnumOptions",
                id: 3
              },
              reservedRange: {
                rule: "repeated",
                type: "EnumReservedRange",
                id: 4
              },
              reservedName: {
                rule: "repeated",
                type: "string",
                id: 5
              }
            },
            nested: {
              EnumReservedRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  }
                }
              }
            }
          },
          EnumValueDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              },
              options: {
                type: "EnumValueOptions",
                id: 3
              }
            }
          },
          ServiceDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              method: {
                rule: "repeated",
                type: "MethodDescriptorProto",
                id: 2
              },
              options: {
                type: "ServiceOptions",
                id: 3
              }
            }
          },
          MethodDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              inputType: {
                type: "string",
                id: 2
              },
              outputType: {
                type: "string",
                id: 3
              },
              options: {
                type: "MethodOptions",
                id: 4
              },
              clientStreaming: {
                type: "bool",
                id: 5,
                options: {
                  "default": false
                }
              },
              serverStreaming: {
                type: "bool",
                id: 6,
                options: {
                  "default": false
                }
              }
            }
          },
          FileOptions: {
            fields: {
              javaPackage: {
                type: "string",
                id: 1
              },
              javaOuterClassname: {
                type: "string",
                id: 8
              },
              javaMultipleFiles: {
                type: "bool",
                id: 10,
                options: {
                  "default": false
                }
              },
              javaGenerateEqualsAndHash: {
                type: "bool",
                id: 20,
                options: {
                  deprecated: true
                }
              },
              javaStringCheckUtf8: {
                type: "bool",
                id: 27,
                options: {
                  "default": false
                }
              },
              optimizeFor: {
                type: "OptimizeMode",
                id: 9,
                options: {
                  "default": "SPEED"
                }
              },
              goPackage: {
                type: "string",
                id: 11
              },
              ccGenericServices: {
                type: "bool",
                id: 16,
                options: {
                  "default": false
                }
              },
              javaGenericServices: {
                type: "bool",
                id: 17,
                options: {
                  "default": false
                }
              },
              pyGenericServices: {
                type: "bool",
                id: 18,
                options: {
                  "default": false
                }
              },
              phpGenericServices: {
                type: "bool",
                id: 42,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 23,
                options: {
                  "default": false
                }
              },
              ccEnableArenas: {
                type: "bool",
                id: 31,
                options: {
                  "default": false
                }
              },
              objcClassPrefix: {
                type: "string",
                id: 36
              },
              csharpNamespace: {
                type: "string",
                id: 37
              },
              swiftPrefix: {
                type: "string",
                id: 39
              },
              phpClassPrefix: {
                type: "string",
                id: 40
              },
              phpNamespace: {
                type: "string",
                id: 41
              },
              phpMetadataNamespace: {
                type: "string",
                id: 44
              },
              rubyPackage: {
                type: "string",
                id: 45
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                38,
                38
              ]
            ],
            nested: {
              OptimizeMode: {
                values: {
                  SPEED: 1,
                  CODE_SIZE: 2,
                  LITE_RUNTIME: 3
                }
              }
            }
          },
          MessageOptions: {
            fields: {
              messageSetWireFormat: {
                type: "bool",
                id: 1,
                options: {
                  "default": false
                }
              },
              noStandardDescriptorAccessor: {
                type: "bool",
                id: 2,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              mapEntry: {
                type: "bool",
                id: 7
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                8,
                8
              ],
              [
                9,
                9
              ]
            ]
          },
          FieldOptions: {
            fields: {
              ctype: {
                type: "CType",
                id: 1,
                options: {
                  "default": "STRING"
                }
              },
              packed: {
                type: "bool",
                id: 2
              },
              jstype: {
                type: "JSType",
                id: 6,
                options: {
                  "default": "JS_NORMAL"
                }
              },
              lazy: {
                type: "bool",
                id: 5,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              weak: {
                type: "bool",
                id: 10,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                4,
                4
              ]
            ],
            nested: {
              CType: {
                values: {
                  STRING: 0,
                  CORD: 1,
                  STRING_PIECE: 2
                }
              },
              JSType: {
                values: {
                  JS_NORMAL: 0,
                  JS_STRING: 1,
                  JS_NUMBER: 2
                }
              }
            }
          },
          OneofOptions: {
            fields: {
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          EnumOptions: {
            fields: {
              allowAlias: {
                type: "bool",
                id: 2
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                5,
                5
              ]
            ]
          },
          EnumValueOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 1,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          ServiceOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 33,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          MethodOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 33,
                options: {
                  "default": false
                }
              },
              idempotencyLevel: {
                type: "IdempotencyLevel",
                id: 34,
                options: {
                  "default": "IDEMPOTENCY_UNKNOWN"
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            nested: {
              IdempotencyLevel: {
                values: {
                  IDEMPOTENCY_UNKNOWN: 0,
                  NO_SIDE_EFFECTS: 1,
                  IDEMPOTENT: 2
                }
              }
            }
          },
          UninterpretedOption: {
            fields: {
              name: {
                rule: "repeated",
                type: "NamePart",
                id: 2
              },
              identifierValue: {
                type: "string",
                id: 3
              },
              positiveIntValue: {
                type: "uint64",
                id: 4
              },
              negativeIntValue: {
                type: "int64",
                id: 5
              },
              doubleValue: {
                type: "double",
                id: 6
              },
              stringValue: {
                type: "bytes",
                id: 7
              },
              aggregateValue: {
                type: "string",
                id: 8
              }
            },
            nested: {
              NamePart: {
                fields: {
                  namePart: {
                    rule: "required",
                    type: "string",
                    id: 1
                  },
                  isExtension: {
                    rule: "required",
                    type: "bool",
                    id: 2
                  }
                }
              }
            }
          },
          SourceCodeInfo: {
            fields: {
              location: {
                rule: "repeated",
                type: "Location",
                id: 1
              }
            },
            nested: {
              Location: {
                fields: {
                  path: {
                    rule: "repeated",
                    type: "int32",
                    id: 1
                  },
                  span: {
                    rule: "repeated",
                    type: "int32",
                    id: 2
                  },
                  leadingComments: {
                    type: "string",
                    id: 3
                  },
                  trailingComments: {
                    type: "string",
                    id: 4
                  },
                  leadingDetachedComments: {
                    rule: "repeated",
                    type: "string",
                    id: 6
                  }
                }
              }
            }
          },
          GeneratedCodeInfo: {
            fields: {
              annotation: {
                rule: "repeated",
                type: "Annotation",
                id: 1
              }
            },
            nested: {
              Annotation: {
                fields: {
                  path: {
                    rule: "repeated",
                    type: "int32",
                    id: 1
                  },
                  sourceFile: {
                    type: "string",
                    id: 2
                  },
                  begin: {
                    type: "int32",
                    id: 3
                  },
                  end: {
                    type: "int32",
                    id: 4
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  user: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      java_outer_classname: "UserModule",
      "(elixir_module_prefix)": "KC.Proto.User",
      swift_prefix: ""
    },
    nested: {
      PresenceMessage: {
        oneofs: {
          presence: {
            oneof: [
              "online",
              "offline",
              "neverSeen"
            ]
          }
        },
        fields: {
          online: {
            type: "Online",
            id: 2
          },
          offline: {
            type: "Offline",
            id: 3
          },
          neverSeen: {
            type: "NeverSeen",
            id: 4
          }
        },
        nested: {
          Online: {
            fields: {}
          },
          Offline: {
            fields: {
              lastSeenInMillis: {
                rule: "required",
                type: "int64",
                id: 1
              }
            }
          },
          NeverSeen: {
            fields: {}
          }
        }
      },
      User: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          postsCount: {
            type: "int32",
            id: 4
          },
          superuser: {
            type: "Superuser",
            id: 5
          },
          userBio: {
            type: "string",
            id: 6
          },
          avatarUrl: {
            type: "string",
            id: 7
          },
          avatarMainColor: {
            type: "int32",
            id: 8
          },
          privateAccount: {
            type: "bool",
            id: 9,
            options: {
              "default": false
            }
          },
          badgeIds: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          presence: {
            type: "PresenceMessage",
            id: 11
          }
        },
        nested: {
          Superuser: {
            fields: {
              DEPRECATEDWebsiteUrl: {
                type: "string",
                id: 1
              },
              location: {
                type: "string",
                id: 2
              },
              coverUrl: {
                type: "string",
                id: 3
              },
              accountType: {
                type: "string",
                id: 4
              },
              followersCount: {
                type: "int32",
                id: 5
              },
              contactEmail: {
                type: "string",
                id: 6
              },
              contactPhoneNumber: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      UserResponse: {
        fields: {
          user: {
            rule: "required",
            type: "user.User",
            id: 1
          }
        }
      },
      PostSuperusersSharersResponse: {
        fields: {
          userIds: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        }
      },
      GetUserByUsernameResponse: {
        fields: {
          userId: {
            type: "string",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        }
      },
      GetUserByUsernameError: {
        fields: {
          code: {
            type: "Code",
            id: 1
          },
          userMessage: {
            type: "string",
            id: 2
          }
        },
        nested: {
          Code: {
            values: {
              UNKNOWN: 0,
              USER_NOT_FOUND: 1
            }
          }
        }
      }
    }
  },
  example: {
    nested: {
      hub: {
        nested: {
          messages: {
            nested: {
              PingClientMessage: {
                fields: {
                  data: {
                    type: "string",
                    id: 1
                  }
                }
              },
              PongServerMessage: {
                fields: {
                  data: {
                    type: "string",
                    id: 1
                  }
                }
              },
              StartCallClientMessage: {
                fields: {
                  participantUserId: {
                    type: "bytes",
                    id: 1
                  },
                  onlyAudio: {
                    type: "bool",
                    id: 2
                  },
                  callId: {
                    type: "bytes",
                    id: 3
                  }
                }
              },
              StartCallErrorServerMessage: {
                fields: {
                  participantUserId: {
                    type: "bytes",
                    id: 1
                  },
                  reason: {
                    type: "string",
                    id: 2
                  },
                  reasonCode: {
                    type: "Reason",
                    id: 5
                  },
                  callId: {
                    type: "bytes",
                    id: 3
                  }
                },
                nested: {
                  Reason: {
                    values: {
                      UNKNOWN: 0,
                      USER_IS_BUSY: 1,
                      YOU_ARE_IN_CALL: 2
                    }
                  }
                }
              },
              IceServer: {
                fields: {
                  uri: {
                    type: "string",
                    id: 1
                  },
                  username: {
                    type: "string",
                    id: 2
                  },
                  password: {
                    type: "string",
                    id: 3
                  }
                }
              },
              DataMessage: {
                oneofs: {
                  data: {
                    oneof: [
                      "sessionsDescription",
                      "iceCandidateAdd",
                      "iceCandidateRemoved",
                      "answererRequestRenegotiation"
                    ]
                  }
                },
                fields: {
                  sessionsDescription: {
                    type: "SessionDescription",
                    id: 1
                  },
                  iceCandidateAdd: {
                    type: "IceCandidateAdd",
                    id: 2
                  },
                  iceCandidateRemoved: {
                    type: "IceCandidateRemoved",
                    id: 3
                  },
                  answererRequestRenegotiation: {
                    type: "AnswererRequestRenegotiation",
                    id: 4
                  }
                },
                nested: {
                  SessionDescription: {
                    fields: {
                      type: {
                        type: "Type",
                        id: 1
                      },
                      description: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Type: {
                        values: {
                          OFFER: 0,
                          PRANSWER: 1,
                          ANSWER: 2
                        }
                      }
                    }
                  },
                  IceCandidate: {
                    fields: {
                      sdpMid: {
                        type: "string",
                        id: 1
                      },
                      sdpMLineIndex: {
                        type: "int32",
                        id: 2
                      },
                      sdp: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  IceCandidateAdd: {
                    fields: {
                      iceCandidate: {
                        rule: "repeated",
                        type: "IceCandidate",
                        id: 1
                      }
                    }
                  },
                  IceCandidateRemoved: {
                    fields: {
                      iceCandidate: {
                        rule: "repeated",
                        type: "IceCandidate",
                        id: 2
                      }
                    }
                  },
                  AnswererRequestRenegotiation: {
                    fields: {}
                  }
                }
              },
              StartedCallServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  iceServers: {
                    rule: "repeated",
                    type: "IceServer",
                    id: 2
                  },
                  onlyAudio: {
                    type: "bool",
                    id: 3
                  },
                  participantUserId: {
                    type: "bytes",
                    id: 4
                  }
                }
              },
              ParticipantReceivedAwaitingCallServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  participantUserId: {
                    type: "bytes",
                    id: 4
                  }
                }
              },
              AwaitingCallServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  callerUserId: {
                    type: "bytes",
                    id: 2
                  },
                  iceServers: {
                    rule: "repeated",
                    type: "IceServer",
                    id: 3
                  },
                  onlyAudio: {
                    type: "bool",
                    id: 4
                  }
                }
              },
              AnswerCallClientMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  }
                }
              },
              AnswerCallErrorServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  reason: {
                    type: "string",
                    id: 2
                  },
                  reasonCode: {
                    type: "Reason",
                    id: 3
                  }
                },
                nested: {
                  Reason: {
                    values: {
                      UNKNOWN: 0,
                      ALREADY_ANSWERED: 1,
                      CALL_CLOSED: 2
                    }
                  }
                }
              },
              SendMessageToCallClientMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  sequence: {
                    type: "uint32",
                    id: 2
                  },
                  data: {
                    type: "DataMessage",
                    id: 3
                  }
                }
              },
              ReceivedMessageFromCallServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  sequence: {
                    type: "uint32",
                    id: 2
                  },
                  data: {
                    type: "DataMessage",
                    id: 3
                  }
                }
              },
              StopCallClientMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  reasonCode: {
                    type: "Reason",
                    id: 2
                  },
                  reasonMessage: {
                    type: "string",
                    id: 3
                  }
                },
                nested: {
                  Reason: {
                    values: {
                      UNKNOWN: 0,
                      DISMISS_CALL: 1,
                      UNKNOWN_FAILURE: 2,
                      SET_REMOTE_DESCRIPTION_FAILURE: 3,
                      SET_LOCAL_DESCRIPTION_FAILURE: 4,
                      SDP_CREATE_FAILURE: 5
                    }
                  }
                }
              },
              StoppedCallServerMessage: {
                fields: {
                  callId: {
                    type: "bytes",
                    id: 1
                  },
                  reason: {
                    type: "string",
                    id: 2
                  },
                  reasonCode: {
                    type: "Reason",
                    id: 3
                  }
                },
                nested: {
                  Reason: {
                    values: {
                      UNKNOWN: 0,
                      INITIATOR_CLOSED: 1,
                      PARTICIPANT_CLOSED: 2,
                      ANSWERED_BY_OTHER_DEVICE: 3,
                      ALREADY_ANSWERED: 4,
                      ALREADY_CLOSED: 5,
                      DEPRECATED_TIMEOUT: 6,
                      NO_RESPONSE: 7,
                      NO_CONNECTION: 8,
                      INITIATOR_FAILED: 9,
                      PARTICIPANT_FAILED: 10,
                      INITIATOR_NETWORK_ISSUE: 11,
                      PARTICIPANT_NETWORK_ISSUE: 12
                    }
                  }
                }
              },
              ClientConainerMessage: {
                oneofs: {
                  data: {
                    oneof: [
                      "startCall",
                      "answerCall",
                      "stopCall",
                      "sendMessage",
                      "ping"
                    ]
                  }
                },
                fields: {
                  startCall: {
                    type: "StartCallClientMessage",
                    id: 1
                  },
                  answerCall: {
                    type: "AnswerCallClientMessage",
                    id: 2
                  },
                  stopCall: {
                    type: "StopCallClientMessage",
                    id: 3
                  },
                  sendMessage: {
                    type: "SendMessageToCallClientMessage",
                    id: 4
                  },
                  ping: {
                    type: "PingClientMessage",
                    id: 5
                  }
                }
              },
              AuthorizationFinishedServerMessage: {
                fields: {
                  userId: {
                    type: "bytes",
                    id: 1
                  },
                  awaitingCallIds: {
                    rule: "repeated",
                    type: "bytes",
                    id: 2
                  },
                  answeredCallIds: {
                    rule: "repeated",
                    type: "bytes",
                    id: 3
                  },
                  outgoingCallIds: {
                    rule: "repeated",
                    type: "bytes",
                    id: 4
                  }
                }
              },
              ServerContainerMessage: {
                oneofs: {
                  data: {
                    oneof: [
                      "startedCall",
                      "awaitingCall",
                      "answerCallError",
                      "stoppedCall",
                      "receiveMessage",
                      "pong",
                      "startCallError",
                      "authorizationFinished",
                      "participantReceivedAwaitingCall"
                    ]
                  }
                },
                fields: {
                  startedCall: {
                    type: "StartedCallServerMessage",
                    id: 1
                  },
                  awaitingCall: {
                    type: "AwaitingCallServerMessage",
                    id: 2
                  },
                  answerCallError: {
                    type: "AnswerCallErrorServerMessage",
                    id: 3
                  },
                  stoppedCall: {
                    type: "StoppedCallServerMessage",
                    id: 4
                  },
                  receiveMessage: {
                    type: "ReceivedMessageFromCallServerMessage",
                    id: 5
                  },
                  pong: {
                    type: "PongServerMessage",
                    id: 6
                  },
                  startCallError: {
                    type: "StartCallErrorServerMessage",
                    id: 7
                  },
                  authorizationFinished: {
                    type: "AuthorizationFinishedServerMessage",
                    id: 8
                  },
                  participantReceivedAwaitingCall: {
                    type: "ParticipantReceivedAwaitingCallServerMessage",
                    id: 9
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;
